import React, { FunctionComponent } from "react";
import { RightFilledBG } from "../../assets/Icons";
import { useRecoilValue } from "recoil";
import { transactionDetails, userDetails } from "../../store";
import { UserTransactionDetails, UserDetails } from "../../store/store";
import IReviewPage from "./ReviewPage";

export const RemittanceDetails: FunctionComponent<IReviewPage.RemittanceDetailsProps> = () => {
  const userData: UserDetails = useRecoilValue(userDetails);
  const transactionData: UserTransactionDetails = useRecoilValue(transactionDetails);

  const accNum = localStorage.getItem("AcNumber");
  const name = localStorage.getItem("recipientName");

  return (
    <div className="flex flex-col w-4/5 mt-6 -ml-8 space-x-2">
      <span className="ml-5 font-bold">Remittance Details</span>
      <div className="flex items-center p-5 rounded-lg">
        <div id="left" className="flex flex-col justify-center p-3 space-y-1">
          <span className="text-[16px] w-full">{userData?.firstName?.slice(0, 20)}</span>
          <div className="flex items-center space-x-3">
            <img src={`/images/png/INR.png`} width="35px" height="35px" />
            <span className="text[14px] font-bold text-gray-500">INDIA</span>
          </div>
        </div>
        <div className="flex justify-center w-1/5">
          <RightFilledBG />
        </div>
        <div id="right" className="flex flex-col p-3 space-y-1">
          <span className="text-[16px]">{name}</span>
          <div className="flex flex-col space-x-3">
            <div className="flex items-center space-x-3">
              <img
                src={`/images/png/${transactionData.dest_currency}.png`}
                width="35px"
                height="35px"
              />
              <span className="text[14px] font-bold text-gray-500">
                {transactionData.dest_currency}
              </span>
            </div>
            <span className="text-[12px] font-semibold">A/C No.: {accNum}</span>
          </div>
        </div>
      </div>
    </div>
  );
};
